import React from "react";
import { CheckCircle2 } from "lucide-react";
import { exams, examImages } from "../mock";

export default function Exams() {
  return (
    <section className="section-navy text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="reveal block text-xs font-semibold tracking-[0.2em] uppercase text-blue-300">
              Exámenes y Diagnóstico
            </span>
            <h2 className="reveal font-display font-extrabold text-3xl lg:text-[2.4rem] leading-tight mt-4">
              Diagnóstico preciso en un solo lugar
            </h2>
            <p className="reveal text-blue-100/70 mt-4 leading-relaxed">
              Realizamos los exámenes especializados que tu tratamiento requiere,
              con equipamiento moderno y resultados oportunos.
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mt-8">
              {exams.map((e, i) => (
                <div
                  key={e}
                  className="reveal flex items-start gap-3 glass-card rounded-xl px-4 py-3.5"
                  style={{ transitionDelay: `${(i % 2) * 70}ms` }}
                >
                  <CheckCircle2 size={18} className="text-blue-300 shrink-0 mt-0.5" />
                  <span className="text-sm text-blue-50/90">{e}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal grid grid-cols-2 gap-4">
            {examImages.map((ex, i) => (
              <div
                key={ex.title}
                className={`relative rounded-2xl overflow-hidden ${i === 0 ? "mt-8" : ""}`}
              >
                <img
                  src={ex.src}
                  alt={ex.title}
                  className="h-64 w-full object-cover bg-black"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071a33]/85 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="text-white font-semibold text-xs leading-tight">{ex.title}</div>
                  <div className="text-blue-100/75 text-[10px] mt-0.5 leading-tight">{ex.caption}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
